module.exports = __webpack_public_path__ + "img/qrcopy-w.b24f3f11.png";